import React, { useEffect, useState, lazy } from 'react';
import { ShieldCheck, Eye } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
import { useCurrency } from './CurrencyContext';
export function PremiumOfferSection() {
  const {
    currency,
    loading,
    formatPrice
  } = useCurrency();
  const [viewers, setViewers] = useState(70);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => {
        // Randomly go up 1-3, occasionally down 1, cap at 120
        const change = Math.random() > 0.2 ? Math.floor(Math.random() * 3) + 1 : -1;
        const next = prev + change;
        return Math.max(65, Math.min(next, 120));
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div id="first-10x1-product" className="mt-2 mb-6" data-id="element-109">
      <div className="bg-white rounded-3xl shadow-[0_4px_30px_rgba(0,0,0,0.06)] border border-[#EDE6D6] p-6 md:p-10 max-w-lg mx-auto pt-[10px] pb-[10px]" data-id="element-110">
        {/* Live Viewer Counter */}
        <div className="flex items-center justify-center gap-2 mb-5 bg-[#FFF8E1] border border-[#F7D060]/40 rounded-full px-4 py-2 max-w-xs mx-auto" data-id="element-111">
          <span className="relative flex h-2.5 w-2.5" data-id="element-112">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#D9A441] opacity-75" data-id="element-113"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#D9A441]" data-id="element-114"></span>
          </span>
          <Eye className="w-4 h-4 text-[#D9A441]" data-id="element-115" />
          <span className="text-sm font-bold text-gray-800" data-id="element-116">
            <span className="text-[#D9A441] font-black" data-id="element-117">{viewers}</span>{' '}
            personas viendo esta oferta
          </span>
        </div>

        {/* Product Image with Badge */}
        <div className="relative mx-auto mb-8 max-w-sm" data-id="element-118">
          <img src="https://cdn.magicpatterns.com/uploads/2HumLHhfW1WXgPEcvSgd57/ChatGPT_Image_10_abr_2026,_09_06_23_p.m..png" alt="Mi Aventura Sin Gluten - Chef Valeria Sartori - eBook" className="w-full rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.10)]" loading="lazy" data-id="element-119" />
          {/* OFERTA 10x1 Badge */}
          <div className="absolute top-3 right-3 bg-gradient-to-br from-[#F7D060] to-[#D9A441] text-gray-900 font-black text-xs md:text-sm px-3 py-1.5 rounded-lg shadow-md rotate-2" data-id="element-120">
            OFERTA 10x1
          </div>
        </div>

        {/* Product Title */}
        <h3 className="text-center md:text-[22px] text-gray-900 mb-3 px-2 font-[Roboto,_sans-serif] font-[800] text-[20px]" data-id="element-121">
          Vuelve a Comer Pan Sin Subir Tu Azúcar — Incluso Si Ya Fallaste Antes
        </h3>
        <div className="flex items-center justify-center gap-2 mb-6 px-4" data-id="element-122">
          <p className="text-[#D9A441]/80 font-medium tracking-wide text-center text-[12px]" data-id="element-123">
            ⚠️ Si sigues comiendo como ahora, tu azúcar seguirá subiendo. 👉
            Esto no es una receta más… es lo que evita que falles otra vez.
          </p>
        </div>

        {/* Price Section */}
        <div className="text-center mb-6" data-id="element-124">
          <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-125">
            {loading ? <span className="inline-block w-32 h-10 bg-gray-100 rounded-lg animate-pulse" data-id="element-126" /> : <>
                <span className="text-[20px] md:text-[24px] font-bold text-gray-400 line-through leading-none" data-id="element-127">
                  {formatPrice(29.5)}
                </span>
                <span className="text-[36px] md:text-[44px] font-black text-gray-900 leading-none" data-id="element-128">
                  {formatPrice(6.95)}
                </span>
              </>}
            {/* 50% OFF Badge */}
            <span className="bg-red-500 text-white text-xs font-black px-2.5 py-1 rounded-md shadow-sm" data-id="element-129">
              50% OFF
            </span>
          </div>
        </div>

        {/* CTA Button */}
        <WhatsAppButton text="👉 SÍ, LO QUIERO" href="YOUR_CHECKOUT_LINK_HERE" data-id="element-130" />

        {/* Urgency Badge */}
        <div className="flex justify-center mt-4" data-id="element-131">
          <span className="inline-flex items-center gap-1.5 bg-red-50 text-red-600 text-xs font-bold px-3 py-1.5 rounded-full border border-red-100" data-id="element-132">
            🔥 Últimos 5 cupos con regalo
          </span>
        </div>

        {/* Trust Text */}
        <div className="flex items-center justify-center gap-1.5 mt-4" data-id="element-133">
          <ShieldCheck className="w-4 h-4 text-gray-400" data-id="element-134" />
          <p className="text-gray-400 text-xs" data-id="element-135">Acceso inmediato vía PDF</p>
        </div>

        {/* Safe Checkout Badges */}
        <div className="mt-4 flex justify-center" data-id="element-136">
          <img src="https://cdn.magicpatterns.com/uploads/sw9mcsR5CMWLuQkfrosGaW/Trust-Badges-Secure-Checkout.png" alt="Métodos de pago seguros: Amex, Apple Pay, Discover, Google Pay, Mastercard, PayPal, Shop Pay, Venmo, Visa" className="max-w-[320px] w-full opacity-80" loading="lazy" data-id="element-137" />
        </div>

        {/* Extra Value Teaser */}
        <p className="text-center md:text-[17px] mt-5 tracking-wide text-[20px] font-[800] text-[#0D0D0C]" data-id="element-138">
          Y hoy… te llevas algo extra que marca la diferencia ✨
        </p>
      </div>
    </div>;
}